import { UseEvent, UseHeader } from "./index";
import useHeader from "./useHeader";
import useFooter from "./useFooter";

let map = {};
export default function UseNavigation() {
  const url = new URL(window.location);
  const header = useHeader();
  const footer = useFooter();
  const ev = UseEvent();
  const navigate = (route, props = {}) => {
    header.check(route);
    footer.check(route);
    ev.emit("navigate", { route, props });
  };
  const push = ({ key, value }) => {
    if (key && value) {
      map[key] = value;
      url.searchParams.set(key, value);
      window.history.pushState({}, "", url);
    }
  };
  const set = ({ key, value }) => {
    if (key && value !== undefined) {
      map[key] = value;
      url.searchParams.set(key, value);
      window.history.replaceState({}, "", url);
    }
  };
  const remove = (key) => {
    if (key) {
      delete map[key];
      url.searchParams.delete(key);
      window.history.replaceState({}, "", url);
    }
  };
  const get = (key) => {
    if (key) {
      return url.searchParams.get(key);
    }
  };
  const getParams = () => {
    let params = {};
    url.searchParams.forEach((v, k) => {
      params[k] = v;
    });
    return params;
  };
  const  isMainPage  = () =>{
     let url = new URL(window.location);

    return url.href === "https://www.lider-bet.com/" ||
      url.href === "https://www.lider-bet.com/ka/" ||
      url.href === "https://www.lider-bet.com/ka" ||
      url.href === "https://www.lider-bet.com/ru/" ||
      url.href === "https://www.lider-bet.com/ru" ||
      url.href === "https://www.lider-bet.com/en/" ||
      url.href === "https://www.lider-bet.com/en" ||
      url.href === "https://reactive.lider-bet.com/" ||
      url.href === "https://reactive.lider-bet.com/ka/" ||
      url.href === "https://reactive.lider-bet.com/ka" ||
      url.href === "https://reactive.lider-bet.com/ru/" ||
      url.href === "https://reactive.lider-bet.com/ru" ||
      url.href === "https://reactive.lider-bet.com/en/" ||
      url.href === "https://reactive.lider-bet.com/en" || url.href === 'https://react.lider-bet.com:3000/';

  }
  return { set, remove, get, map, getParams, navigate, push,isMainPage };
}
